import { InMemoryCache, defaultDataIdFromObject } from '@apollo/client/cache';
import { makeVar } from '@apollo/client';
import { store } from './resolvers/store';
import { productQtyResolver } from './resolvers/product-qty';

const isServer = typeof window === 'undefined';
const preloadedCache = isServer ? {} : window.__APOLLO_STATE__;

export const selectedStore = isServer ? f => f : makeVar();
export const productQtyVar = isServer ? f => f : makeVar(1);

export const newCache = () =>
  new InMemoryCache({
    dataIdFromObject: object => {
      if (object.__typename === 'Params') {
        return `${object.id}-${object.value}`;
      }
      return defaultDataIdFromObject(object);
    },
    cacheRedirects: {
      Query: {
        product: (_, args, { getCacheKey }) => getCacheKey({ __typename: 'Product', id: args.productId }),
      },
    },
    typePolicies: {
      SelectedAggregation: {
        keyFields: ['id', 'title'],
      },
      Aggregation: {
        keyFields: false,
      },
      Product: {
        keyFields: false,
      },
      Query: {
        fields: {
          page: {
            keyArgs: ['path'],
            merge(existing, incoming) {
              return { ...existing, ...incoming };
            },
          },
          product: {
            keyArgs: ['productId'],
            merge(existing, incoming) {
              return { ...existing, ...incoming };
            },
          },
          selectedStore: store(selectedStore),
          productQty: productQtyResolver(productQtyVar),
          cookies: {
            merge(existing, incoming) {
              return { ...existing, ...incoming };
            },
          },
        },
      },
    },
  }).restore(preloadedCache);
